<div
  class="tags-wrapper custom-chip"
  miqTagClipboardKeyboard
  [selectedTagIds]="selectedTagIds"
  [viewTags]="tags"
  [enableClipboardFeatures]="isClipboardSupported"
  [canEdit]="canEdit"
  [entityId]="entityId"
  (clipboardCut)="onClipboardCut($event)"
  (clipboardPaste)="onClipboardPaste($event)"
>
  <mat-chip-grid #tagList>
    <mat-chip-row
      *ngFor="let tag of tags"
      [removable]="canEdit"
      (removed)="remove(tag)"
      [ngClass]="{ 'tag-selected': isTagSelected(tag) }"
      (click)="onChipClick(tag, $event)"
      [id]="'tag-chip-' + tag.internalId"
    >
      {{ tag.display }}
      <mat-icon *ngIf="canEdit" matChipRemove>clear</mat-icon>
    </mat-chip-row>
    <input
      matInput
      miqAvoidSpecialChars
      [miqAllowCharacter]="allowedChars"
      placeholder="{{ 'shared.addTag' | xTranslate }}"
      #tagsInput
      [formControl]="tagCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="tagList"
      [hidden]="!canEdit"
      (paste)="onPaste($event)"
      (keydown.enter)="onClickEnter($event)"
    />
  </mat-chip-grid>
  <mat-autocomplete class="tag-menus" #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let tag of filteredTags | async" [value]="tag">
      {{ tag.display }}
    </mat-option>
  </mat-autocomplete>
</div>
